var _circle, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelfDestruction1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 91,
    viewBox: "0 0 108 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#D11C1C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_13710)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18,
    width: 88,
    height: 73,
    rx: 5,
    fill: "url(#paint0_linear_1_13710)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 18.5,
    width: 87,
    height: 72,
    rx: 4.5,
    stroke: "url(#paint1_linear_1_13710)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_13710)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_13710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.25 52.9H52.983L52.5495 55.5H50.6534C49.9098 55.5 49.2423 55.9134 48.9095 56.5777L47.9689 58.4595C47.8682 58.661 47.8792 58.9002 47.9975 59.0919C48.1158 59.2837 48.3245 59.4 48.55 59.4H61.55C61.7756 59.4 61.9842 59.283 62.1032 59.0913C62.2221 58.8995 62.2325 58.6603 62.1318 58.4588L61.1912 56.5771C60.8584 55.9134 60.1902 55.5 59.4466 55.5H57.5506L57.117 52.9H62.85C64.7409 52.9 66.1 50.0407 66.1 49.65V40.55C66.1 37.1954 64.4211 36 62.85 36H47.25C45.458 36 44 37.458 44 39.25V49.65C44 51.4421 45.458 52.9 47.25 52.9ZM60.0277 57.1595L60.4983 58.1H49.6017L50.0723 57.1595C50.1828 56.9378 50.4058 56.8 50.6534 56.8H53.1H57H59.4466C59.6943 56.8 59.9172 56.9378 60.0277 57.1595ZM56.2324 55.5H53.867L54.3006 52.9H55.7995L56.2324 55.5ZM62.85 51.6H56.35H53.75H47.25C46.4037 51.6 45.6887 51.0547 45.4196 50.3H64.384C63.9869 50.9091 63.3947 51.6 62.85 51.6ZM47.25 37.3H62.85C64.0896 37.3 64.8 38.4843 64.8 40.55V49H45.3V39.25C45.3 38.1749 46.1749 37.3 47.25 37.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0493 47.7001C57.5583 47.7001 59.5993 45.6585 59.5993 43.1501C59.5993 42.4689 59.4446 41.8241 59.1748 41.2436L60.0588 40.3596L59.1397 39.4405L58.4462 40.1341C57.6122 39.1955 56.4006 38.6001 55.0493 38.6001C52.5403 38.6001 50.4993 40.6417 50.4993 43.1501C50.4993 45.6585 52.5403 47.7001 55.0493 47.7001ZM55.0493 39.9001C56.0425 39.9001 56.9219 40.3577 57.5186 41.0616L55.0493 43.531L53.5588 42.0405L52.6397 42.9597L54.5897 44.9097C54.7165 45.0364 54.8829 45.1001 55.0493 45.1001C55.2157 45.1001 55.3821 45.0364 55.5088 44.9097L58.1595 42.2589C58.2414 42.5443 58.2993 42.8388 58.2993 43.1501C58.2993 44.9422 56.8413 46.4001 55.0493 46.4001C53.2572 46.4001 51.7993 44.9422 51.7993 43.1501C51.7993 41.358 53.2572 39.9001 55.0493 39.9001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0502 60.0491C80.5491 60.0491 80.096 60.2447 79.7502 60.5561C79.4044 60.2441 78.9514 60.0491 78.4502 60.0491C77.9491 60.0491 77.496 60.2447 77.1502 60.5561C76.8044 60.2441 76.3514 60.0491 75.8502 60.0491C75.6214 60.0491 75.4043 60.0959 75.2002 60.1687V58.7491C75.2002 57.674 74.3253 56.7991 73.2502 56.7991C72.1751 56.7991 71.3002 57.674 71.3002 58.7491V63.03L68.8906 65.4395C68.7684 65.5611 68.7002 65.7262 68.7002 65.8991V71.7491C68.7002 71.8901 68.7457 72.0266 68.8302 72.1391L70.7802 74.7391C70.9024 74.9029 71.0954 74.9991 71.3002 74.9991H82.3502C82.709 74.9991 83.0002 74.7085 83.0002 74.3491V66.5491V61.9991C83.0002 60.924 82.1253 60.0491 81.0502 60.0491ZM81.7002 73.6991H71.6252L70.0002 71.5326V66.1682L71.3002 64.8682V66.5491H72.6002V63.2991V58.7491C72.6002 58.3903 72.892 58.0991 73.2502 58.0991C73.6083 58.0991 73.9002 58.3903 73.9002 58.7491V61.9991V66.5491H75.2002V61.9991C75.2002 61.6403 75.4921 61.3491 75.8502 61.3491C76.2084 61.3491 76.5002 61.6403 76.5002 61.9991V66.5491H77.8002V61.9991C77.8002 61.6403 78.0921 61.3491 78.4502 61.3491C78.8084 61.3491 79.1002 61.6403 79.1002 61.9991V66.5491H80.4002V61.9991C80.4002 61.6403 80.6921 61.3491 81.0502 61.3491C81.4084 61.3491 81.7002 61.6403 81.7002 61.9991V66.5491V73.6991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8994 48.3501H72.5994V52.2501H73.8994V48.3501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2914 50.4899L76.0415 53.7399L76.9607 54.6591L80.2107 51.4092L79.2914 50.4899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2107 50.4902L66.2915 51.4094L69.5414 54.6594L70.4607 53.7401L67.2107 50.4902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3502 56.7991H78.4502V58.0991H82.3502V56.7991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0506 56.7991H64.1506V58.0991H68.0506V56.7991Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_13710",
    x: -5,
    y: -7,
    width: 138,
    height: 123,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_13710"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_13710",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_13710",
    x: 40,
    y: 36,
    width: 47.0002,
    height: 46.999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_13710"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_13710",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_13710",
    x1: -9.17563,
    y1: -51.6818,
    x2: 61.8865,
    y2: -38.3225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBFB",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_13710",
    x1: 106.029,
    y1: 67.5515,
    x2: 40.0421,
    y2: 62.8705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_13710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(42 33)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfDestruction1);
export default __webpack_public_path__ + "static/media/selfDestruction1.ce1764a06b83ac7aed71f6267c8ee324.svg";
export { ForwardRef as ReactComponent };